<template>
  <div class="login-wrap">
    <div class="login-content">
      <div class="login-box">
        <div class="login-body">
          <Qrcode @handleLogin="handleLogin" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './login.scss'
import Qrcode from './type'
import {
  setStorageToken,
  setStorageAdminUser,
  setStorageUserRoleId,
  setStorageUserRoleName,
  setActionData,
  setStorageUserIsLogin,
  getStorageUserIsLogin
} from "@/utils/store";
import { mapActions, mapState } from "vuex";
import { GetManagementImUser, GetUserSingleChats } from '@/service/webImApi.js'
import { initEffects } from "@/utils/specialEffects.js";

export default {
  components: {
    Qrcode
  },
  data() {
    return {

    };
  },
  computed: {
    ...mapState({
      currentMenu: (state) => state.app.currentMenu,
      menuList: (state) => state.app.menuList,
      menuMapById: (state) => state.app.menuMapById,
    }),
  },
  methods: {
    ...mapActions("app", ["setUserData", "setUserRole"]),
    async handleLogin(loginData) {
      if (loginData.Result != 1) {
        return this.$message.error(loginData.Message);
      }
      setStorageToken(loginData.Token);
      setActionData(loginData.ActionData)
      let user_admin = {
        role_id: loginData.AccountID,
        nickname: loginData.AccountName,
        remark: loginData.Remark,
        roleName: loginData.RoleNameList,
      }
      setStorageUserRoleId(user_admin.role_id);

      //存储id，用于设置登录有效期
      const millisecondsInDay = 2 * 24 * 60 * 60 * 1000; // 2天
      setStorageUserIsLogin(user_admin.role_id, millisecondsInDay);

      setStorageAdminUser(user_admin);
      this.loginWebIm(user_admin.role_id)
      setStorageUserRoleName(loginData.AccountName);
      let rres = await this.setUserRole({
        id: loginData.AccountID,
        isLoad: true,
      });

      if (rres) {
        if (!this.menuList.length) {
          this.$message.warning(
            "该帐号无权限，请联系管理员添加权限!"
          );
          return 0
        }
        this.$message.success("登录成功!");
        initEffects();//初始化特效
        if (
          this.currentMenu.id &&
          this.menuMapById[this.currentMenu.id]
        ) {
          this.$router.push(this.currentMenu.path);
        } else {
          //优先跳工单列表
          console.info("menuList",this.menuList);
          var jobmenu = this.menuList.find(m => m.name == "工单管理");
          var path = "";
          if (jobmenu) {
            path = jobmenu.children[0].path;
          }
          else {
            let first =
              this.menuList[0].children.length &&
                this.menuList[0].children[0].hideMenu
                ? this.menuList[0].children[1]
                : this.menuList[0].children[0];

            path = first.path;
          }

          this.$router.push(path);
        }
        return 1
      } else {
        this.$message.warning("权限获取失败，请联系管理员!");
        return 0
      }
    },
    loginWebIm(role_id) {
      let params = {
        platform: 'pcweb',
        userId: role_id
      };
      console.log("获取环信登录名和密码", params);
      //获取环信登录名和密码
      GetManagementImUser(params).then(r => {
        if (r.Result == 1) {
          this.$store.dispatch('onLogin', {
            username: r.Data.ImUserId,
            password: r.Data.ImUserPassWord
          })
          GetUserSingleChats({
            PageSize: 999,
            PageNo: 1,
            UserCode: r.Data.ImUserId.split('-')[1],
            platform: 'pcweb'
          }).then(chatRes => {
            console.log("chatRes ############", chatRes);
            if (chatRes.Result == 1) {
              let arr = [];
              if (r.Data.ImUserId) {
                arr = arr.concat(chatRes.Data.FriendsLines);
              }
              this.$store.commit('setSingleChatList', arr);
            }
          })

        }
      })
    },
  }
};
</script>